import React, { useEffect, useState } from 'react';
import { LocalizeProvider, withLocalize } from 'react-localize-redux';
import _ from 'lodash';
import { AllLanguageTypes, allTranslations, getLocalizeOptions } from '@tradingblock/types';
const LocalizeWrapper = ({ initialize, addTranslationForLanguage, children }) => {
    const [localizeInitialized, setLocalizeInitialized] = useState(false);
    useEffect(() => {
        if (!localizeInitialized) {
            initialize(getLocalizeOptions(AllLanguageTypes));
            _.each(allTranslations, (translations, lang) => {
                addTranslationForLanguage(translations, lang);
            });
            window.setTimeout(() => setLocalizeInitialized(true), 10);
        }
    }, [localizeInitialized, initialize, addTranslationForLanguage]);
    // wait for localize to be initialized with data
    if (!localizeInitialized) {
        return null;
    }
    return React.createElement(React.Fragment, null, children);
};
const LocalizeWrapperWithLocalize = withLocalize(LocalizeWrapper);
export const LocalizeProviderWrapper = ({ children }) => (React.createElement(LocalizeProvider, null,
    React.createElement(LocalizeWrapperWithLocalize, null, children)));
//# sourceMappingURL=LocalizeProviderWrapper.js.map